var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 9.84688C7.775 7.87813 9.72813 6.5 12 6.5C13.2406 6.5 14.4312 6.99375 15.3094 7.87188L16.9406 9.5H15.25C14.8344 9.5 14.5 9.83437 14.5 10.25C14.5 10.6656 14.8344 11 15.25 11H18.75C19.1656 11 19.5 10.6656 19.5 10.25V6.75C19.5 6.33438 19.1656 6 18.75 6C18.3344 6 18 6.33438 18 6.75V8.44063L16.3719 6.80938C15.2125 5.65 13.6406 5 12 5C9.10625 5 6.62187 6.75625 5.55625 9.25938C5.39375 9.64062 5.57187 10.0813 5.95312 10.2438C6.33438 10.4062 6.775 10.2281 6.9375 9.84688ZM18.4375 14.7531C18.6 14.3719 18.425 13.9313 18.0437 13.7688C17.6625 13.6062 17.2219 13.7812 17.0594 14.1625C16.2188 16.1281 14.2688 17.5 12 17.5C10.7594 17.5 9.56875 17.0063 8.69063 16.1281L7.05938 14.5H8.75C9.16563 14.5 9.5 14.1656 9.5 13.75C9.5 13.3344 9.16563 13 8.75 13H5.25C4.83437 13 4.5 13.3344 4.5 13.75V17.25C4.5 17.6656 4.83437 18 5.25 18C5.66562 18 6 17.6656 6 17.25V15.5594L7.62812 17.1875C8.7875 18.35 10.3594 19 12 19C14.8906 19 17.3687 17.25 18.4375 14.7531Z",
    fill: "#778187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdate);
export default __webpack_public_path__ + "static/media/IconUpdate.36660159b2a6ed0c427f1fdc04d9eb09.svg";
export { ForwardRef as ReactComponent };